import { API_REFERENCE } from '../utilities/constant_api';
import {
  formatPhoneNumber,
  numbersOnly,
  restrictInvalidCharacters
} from '../utilities/utility';
import { jsonPost } from '../components/ajax';

const $doc = $(document);
const accountInformationEdit = '.edit--checkout-account-settings';
const phoneNumberRange = {
  secondaryPhone: 'secondaryPhone',
  secondaryPhoneType: 'secondaryPhoneType',
  tertiaryPhone: 'tertiaryPhone',
  tertiaryPhoneType: 'tertiaryPhoneType'
};
let phoneNumberCount = 0;
let checkoutRemovePhoneNumberAjaxFlag = true;
let nextStepForm = false;
const accountInfomationViewMode = '.checkout-account-information-view';
const accountInformationEditMode = '.checkout-account-information-edit';
const accountContactCount = '.checkout-phone-count';
const accountCheckoutPhoneFormat = '.checkout-number-format';
const hiddenCheckoutContactForm = '#hidden-checkout-phone-form';
const checkouAccountInformationForm = '#chhUpdateProfileForm';
const checkoutValidRequireField = '.valid-required-field';
const checkoutPhoneTypeEle =
  '.checkout-primary-number-type-edit, .checkout-secondary-number-type-edit';
const checkoutAccountInformation = {
  editAccountInformation() {
    $(accountInfomationViewMode).hide();
    $(accountInformationEditMode).show();
    phoneNumberCount = $(accountContactCount).length;
    $(accountCheckoutPhoneFormat).each(function() {
      $(this).val(formatPhoneNumber($(this).val()));
    });
    $('.checkout-tertiary-number-type-edit').selectmenu();
  },
  phoneNumberHtml(phoneNumber, phoneNumberType) {
    $(checkoutPhoneTypeEle).selectmenu('destroy');
    $(hiddenCheckoutContactForm)
      .find('.add-checkout-phone-class')
      .addClass('checkout-phone-count mt-4 dropdown selection-group')
      .removeClass('add-checkout-phone-class');
    $(hiddenCheckoutContactForm)
      .find('.checkout-number-format')
      .attr('name', phoneNumber);
    $(hiddenCheckoutContactForm)
      .find('.checkout-secondary-number-type-edit')
      .attr('name', phoneNumberType);
    $(hiddenCheckoutContactForm)
      .find('.checkout-secondary-number-type-edit')
      .attr('aria-label', phoneNumberType);
    if (!$('label').hasClass('accessibility_label')) {
      $(hiddenCheckoutContactForm)
        .find('.checkout-secondary-number-type-edit')
        .before('<label class="accessibility_label sr-only">phone</label>');
    }

    $(hiddenCheckoutContactForm)
      .find('.checkout-phone-radio')
      .val(phoneNumber);
    const checkoutPhoneForm = $(hiddenCheckoutContactForm).html();
    $(accountContactCount)
      .last()
      .after(checkoutPhoneForm);
    phoneNumberCount = $(accountContactCount).length;
    $(hiddenCheckoutContactForm)
      .find(accountContactCount)
      .addClass('add-checkout-phone-class')
      .removeClass('checkout-phone-count');
    $(checkoutPhoneTypeEle).selectmenu();
  },
  addPhoneNumberElement() {
    phoneNumberCount = $(accountContactCount).length;
    if (phoneNumberCount < 3) {
      if (phoneNumberCount === 1) {
        checkoutAccountInformation.phoneNumberHtml(
          phoneNumberRange.secondaryPhone,
          phoneNumberRange.secondaryPhoneType
        );
      } else if (phoneNumberCount === 2) {
        checkoutAccountInformation.phoneNumberHtml(
          phoneNumberRange.tertiaryPhone,
          phoneNumberRange.tertiaryPhoneType
        );
      }
    }
  },
  preventNextStepButton(){
    if(!nextStepForm){
      nextStepForm = true;
      $('#checkout_account-information-form').submit();
    }
  },
  submitCheckoutAccountForm(e) {
    let accountFormValid = true;
    e.preventDefault();
    $(`${checkouAccountInformationForm} ${checkoutValidRequireField}`).each(
      function() {
        if ($(this).val() === '' || $(this).val() === null) {
          if ($(this).is('select')) {
            $(this)
              .parent()
              .find('.ui-selectmenu-button')
              .addClass('error-msg-textbox');
            $(this)
              .parent()
              .find('.error-msg-text')
              .show();
          } else {
            $(this)
              .addClass('error-msg-textbox')
              .parent()
              .find('.error-msg-text')
              .show();
          }

          accountFormValid = accountFormValid && false;
        } else if (!($(this).val() === '' || $(this).val() === null)) {
          if ($(this).hasClass('checkout-number-format')) {
            if ($(this).val().length < 12) {
              $(this)
                .addClass('error-msg-textbox')
                .next()
                .show();
              accountFormValid = accountFormValid && false;
            } else {
              $(this)
                .next()
                .hide();
              accountFormValid = accountFormValid && true;
            }
          } else if ($(this).hasClass('checkout-name-valid-pattern')) {
            if ($(this)[0].validity.patternMismatch) {
              $(this)
                .next()
                .show();
              accountFormValid = accountFormValid && false;
            } else {
              $(this)
                .next()
                .hide();
              accountFormValid = accountFormValid && true;
            }
          } else {
            $(this)
              .removeClass('error-msg-textbox')
              .parent()
              .find('.error-msg-text')
              .hide();
            accountFormValid = accountFormValid && true;
          }
        }
      }
    );
    if (accountFormValid) {
      $('#chhUpdateProfileForm .checkout-number-format')
        .first()
        .attr('name', $('input[name=phoneInformation]:checked').val());
      $('#chhUpdateProfileForm select')
        .first()
        .attr('name', `${$('input[name=phoneInformation]:checked').val()}Type`);
      $('input[name=phoneInformation]:checked')
        .closest(accountContactCount)
        .find('.checkout-number-format')
        .attr('name', 'primaryPhone');
      $('input[name=phoneInformation]:checked')
        .closest(accountContactCount)
        .find('select')
        .attr('name', 'primaryPhoneType');
      $('#chhUpdateProfileForm .checkout-number-format').each(function() {
        $(this).val(
          $(this)
            .val()
            .split('.')
            .join('')
        );
      });
      $('#chhUpdateProfileForm').submit();
    }
  },
  removeCheckoutPhoneNumber() {
    const data = $(this)
      .closest(accountContactCount)
      .find('.checkout-number-format')
      .val()
      .split('.')
      .join('')
      .toString();
    if (!checkoutRemovePhoneNumberAjaxFlag) return false;
    checkoutRemovePhoneNumberAjaxFlag = false;
    jsonPost(`${API_REFERENCE.checkoutAccount.removeContact}${data}`)
      .then(() => {
        checkoutRemovePhoneNumberAjaxFlag = true;
        $(this)
          .closest(accountContactCount)
          .remove();
        phoneNumberCount = $(accountContactCount).length;
      })
      .catch(error => {
        checkoutRemovePhoneNumberAjaxFlag = true;
      });
  },
  changesRadioCheckedStatus() {
    $('input[name=phoneInformation]').removeAttr('checked');
    $(this).attr('checked', true);
  },
  changePhoneNumverViewFormat() {
    $('.checkout-phone-view-format').each(function() {
      $(this).text(formatPhoneNumber($(this).text()));
    });
  },
  validateInputField(e) {
    var regExp = new RegExp("^[a-zA-Z 0-9'-]+$");
    return restrictInvalidCharacters(e, regExp);
  },
  init() {
    this.changePhoneNumverViewFormat();
    $(accountInformationEdit).on('click', this.editAccountInformation);

    $doc.on('keypress', '.checkout-number-format', function(e) {
      const format = numbersOnly(e);
      if (format) {
        const thisPhone = $(this);
        const curval = $(this).val();
        thisPhone.val(formatPhoneNumber(curval));
      } else {
        return false;
      }
      return null;
    });
    $('.checkout-add-phone').on('click', this.addPhoneNumberElement);
    $('#continueButton').on('click', this.preventNextStepButton);
    $('.checkout-account-form-save').on(
      'click',
      this.submitCheckoutAccountForm
    );
    $doc.on(
      'click',
      '.checkout-account-remove-phone',
      this.removeCheckoutPhoneNumber
    );
    $('.checkout-phone-radio').on('click', this.changesRadioCheckedStatus);
    $doc.on(
      'keypress',
      '#chhUpdateProfileForm .checkout-name-valid-pattern',
      this.validateInputField
    );
    $(checkoutPhoneTypeEle).selectmenu();
  }
};

checkoutAccountInformation.init();

export default checkoutAccountInformation;
